import { Fragment, useEffect, useState } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import logo_text from './assets/logo_text.png';
import Routes from './Routes';
import { Link } from 'react-router-dom';
import ProfileBtn from './components/ProfileBtn';
import { supabase } from './supabase';
import { Drawer } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faXmark } from '@fortawesome/free-solid-svg-icons';
import { Modal } from 'react-bootstrap';
import Onboarding from './pages/Onboarding';

export default function App() {

  const baseURL = window.location.href.includes("localhost") ? "http://localhost:3000" : "http://eggshelliq.com";
  
  // get local storage
  let initSession = localStorage.getItem("sb-wtlkhsfpanurgzhaiocq-auth-token");
  if (initSession) {
    initSession = JSON.parse(initSession);
  }
  const [session, setSession] = useState(initSession);
  const [openOnboardingModal, setOpenOnboardingModal] = useState(false);

  useEffect(() => {
    const getProfile = async (session) => {
      try {
        let { data, error, status } = await supabase
          .from('Profile')
          .select('onboarded')
          .eq('id', session.user.id);

        if (error && status !== 406) {
            throw error
        }
        
        if (data.length === 0 || data[0].onboarded === false) {
          setOpenOnboardingModal(true);
        }

      } catch (error) {
          console.log(error.message);
      }
    }

    supabase.auth.onAuthStateChange((event, session) => {
      setSession(session);

      // check if user has been onboarded
      getProfile(session);

      // redirect user to new window
      let currentURL = window.location.href;
      if (session) {
        if (currentURL === `${baseURL}/login`) {
          window.location.href = `${baseURL}/dashboard`;
        }
      } else {
        if (currentURL.includes("dashboard")) {
          window.location.href = baseURL;
        }
      }
    })

    // eslint-disable-next-line
  }, [])

  // drawer for mobile
  const [drawer, setDrawer] = useState({
    right: false
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setDrawer({ ...drawer, [anchor]: open });
  };

  const handleSignOut = async () => {
    await supabase.auth.signOut();
    setTimeout(function() { window.location.reload(true) }, 100);
  };
  
  // determine if mobile
  const [width, setWidth] = useState(window.innerWidth);
  function handleWindowSizeChange() {
      setWidth(window.innerWidth);
  }
  useEffect(() => {
      window.addEventListener('resize', handleWindowSizeChange);
      return () => {
          window.removeEventListener('resize', handleWindowSizeChange);
      }
  }, []);
  const isMobile = width <= 768;

  return (
    <div style={{width: '100%'}}>
      <ToastContainer />

      {/* Onboarding modal */}
      <Modal size={'lg'} centered={true} show={openOnboardingModal} onHide={() => setOpenOnboardingModal(false)}>
        <Modal.Body className={`${isMobile ? 'mx-2' : 'mx-8'} mt-1 mb-5`}>
            <div className="flex justify-between">
                <img src={logo_text} alt="logo" className='h-7 mt-2' />
                {/* Close modal */}
                <FontAwesomeIcon
                    icon={faXmark}
                    onClick={() => setOpenOnboardingModal(false)}
                    style={{ paddingLeft: '14px', paddingRight: '14px' }}
                    className='text-xl py-2.5 -mt-1 -mr-5 cursor-pointer rounded-full hover:bg-light-gray-2'
                />
            </div>
            <Onboarding
              session={session}
              setOpenOnboardingModal={setOpenOnboardingModal}
            />
        </Modal.Body>
      </Modal>
      
      {/* Nav bar */}
      {isMobile ? (
        <div className='flex justify-between p-3'>
          <Link to='/' className='pt-2 pl-3 font-semibold'>
            <img src={logo_text} className='h-8' alt='Eggshell logo' />
          </Link>
          <Fragment key={'right'}>
            <button
                onClick={toggleDrawer('right', true)}
                className='bg-light-gray hover:bg-light-gray-2 px-4 py-2.5 rounded-xl mb-3'
            >
                <FontAwesomeIcon icon={faBars} className="text-2xl text-gray" />
            </button>
            <Drawer
              anchor={'right'}
              open={drawer['right']}
              onClose={toggleDrawer('right', false)}
              >
              <div
                style={{width: '100vw'}}
                onClick={toggleDrawer('right', false)}
                className='px-3 pt-3 pr-2 flex flex-col gap-5'
              >
                <div className='flex justify-between mr-9'>
                  <Link to='/' className='pt-2 pl-3 font-semibold'>
                    <img src={logo_text} className='h-8' alt='Eggshell logo' />
                  </Link>
                  <FontAwesomeIcon
                    icon={faXmark}
                    style={{ paddingLeft: '14px', paddingRight: '14px' }}
                    className='text-xl text-gray py-2.5 mt-1 -mr-5 cursor-pointer hover:rounded-full hover:bg-light-gray-2'
                  />
                </div>
                <div className='flex flex-col gap-2 mt-5 text-xl'>
                  <Link to='/dashboard' className={`${session ? '' : 'hidden'} pl-4 py-4 hover:bg-light-gray-2 hover:no-underline font-semibold rounded-xl hover:text-black`}>
                    <p>Dashboard</p>
                  </Link>
                  <a className='pl-4 py-4 hover:bg-light-gray-2 hover:no-underline font-semibold rounded-xl hover:no-underline hover:text-black' href={`${baseURL}/#services`}>Services</a>
                  <a className='pl-4 py-4 hover:bg-light-gray-2 hover:no-underline font-semibold rounded-xl hover:no-underline hover:text-black' href={`${baseURL}/#contact`}>Contact</a>
                  {session ? (
                    <div className='mt-3 mx-4' onClick={() => handleSignOut()}>
                      <p className='w-full text-white text-center font-bold py-2 bg-eggshell-green hover:bg-eggshell-dark-green rounded-xl'>Log out</p>
                    </div>
                  ) : (
                    <Link to='/login' className='mt-3 mx-4'>
                      <p className='w-full text-white text-center font-bold py-2 bg-eggshell-green hover:bg-eggshell-dark-green rounded-xl'>Login</p>
                    </Link>
                  )}
                </div>
              </div>
            </Drawer>
          </Fragment>
        </div>
      ) : (
        <div className='fixed bg-white flex justify-between tracking-wide lg:px-32 pt-2 pb-4 text-xl' style={{width: '100vw'}}>
          <div className='flex justify-start gap-5 pt-3'>
            <Link to='/' className='pt-2 pl-3 font-semibold pr-6'>
              <img src={logo_text} className='h-8' alt='Eggshell logo' />
            </Link>
            <Link to='/dashboard' className={`${session ? '' : 'hidden'} px-4 py-2 text-base hover:bg-light-gray-2 font-semibold rounded-xl hover:no-underline hover:text-black`}>
              <p>Dashboard</p>
            </Link>
            <a className='px-4 py-2 text-base hover:bg-light-gray-2 font-semibold rounded-xl hover:no-underline hover:text-black' href={`${baseURL}/#services`}>Services</a>
            <a className='px-4 py-2 text-base hover:bg-light-gray-2 font-semibold rounded-xl hover:no-underline hover:text-black' href={`${baseURL}/#contact`}>Contact</a>
          </div>
          <div className={`flex justify-center gap-5 ${isMobile ? 'gap-2' : 'gap-5'}`}>
            {session ? (
              <ProfileBtn session={session} />
            ) : (
              <Link to='/login' className='mt-3 hover:no-underline'>
                <p className='px-6 text-white text-base font-bold py-2 bg-eggshell-green hover:bg-eggshell-dark-green rounded-xl'>Login</p>
              </Link>
            )
            }
          </div>
        </div>
      )}

      <div className='pt-20'>
        <Routes />
      </div>

    </div>
  )
}
